import React, { ReactNode } from "react";

interface HeaderNav {
  children?: ReactNode;
}

const HeaderNav: React.FC<HeaderNav> = ({ children }) => {
  return <div className=" pb-2 pt-5  ">{children}</div>;
};

export default HeaderNav;
